module.exports = __webpack_public_path__ + "media/application/images/logo_retina-5cd1485b0e7cb2db881336f6ae6803f6.jpg";